<template>
  <div class="similar-fac">
    <h2 class="sub-heading">
      {{ title }}
    </h2>
    <ul>
      <li v-for="(facilityService, index) in facilityServices" :key="index">
        <nuxt-link :to="facilityService.url">{{
          facilityService.title
        }}</nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { createUrl } from '@/utils/create-url'
import { methods } from '@/utils/methods'
export default {
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      return (
        this.detail.prefecture +
        'で同じ設備がある格安セミナー会場（貸し会議室・ホール・レンタルスペース）を探す'
      )
    },
    facilityServices() {
      const serviceList = methods.getServiceList()

      return this.detail.service.map((code) => {
        const query = {
          prefecture: this.detail.prefecture,
          service: [code]
        }
        const label = serviceList.find(
          (master) => master.value === code.toString()
        ).name
        const url = createUrl.createSearchUrl(query)
        return {
          title:
            this.detail.prefecture + 'の' + label + 'がある格安セミナー会場',
          url
        }
      })
    }
  }
}
</script>
